export default __webpack_public_path__ + "static/deep-tech-72f1b0eefa03d15a21da1451bc0b6be4.png";